import React, { useEffect, useState } from "react";
import { Modal, ModalDialog, Button, CircularProgress } from "@mui/joy";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getFetch } from "../../../../../fetch/fetch";

/**
 * 윈터 스쿨 등록 관리 > '결제링크 발송시각' 숫자 클릭 → 그 예약자의 발송 이력 (GET /dashboard/payments/winterpay/sendhistory?prereserveId=)
 * 성공 건만 발송 횟수로 센다. 실패 건은 사유와 함께 회색으로 보여준다.
 * props: open, onClose, target({id, name, phoneNumber})
 */

const toastOptions: any = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    theme: "colored",
};

const formatDateTime = (v: any) => {
    if (!v) return "-";
    const d = new Date(v);
    if (isNaN(d.getTime())) return String(v);
    const p = (n: number) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
};

const WinterSendHistoryModal: React.FC<any> = (props) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [rows, setRows] = useState<any[]>([]);

    useEffect(() => {
        if (!props.open || !props.target) return;
        setRows([]);
        load(props.target.id);
    }, [props.open, props.target]);

    const load = async (prereserveId: number) => {
        try {
            setLoading(true);
            const result: any = await getFetch(`/dashboard/payments/winterpay/sendhistory?prereserveId=${prereserveId}`);
            if (result.message === "success") {
                setRows(result.data || []);
            } else {
                console.log(result);
                toast.error("발송 이력을 불러오지 못했습니다", toastOptions);
            }
        } catch (e) {
            console.log(e);
            toast.error("발송 이력을 불러오지 못했습니다", toastOptions);
        } finally {
            setLoading(false);
        }
    };

    const successRows = rows.filter((r) => r.status === "success");
    const cell: React.CSSProperties = { padding: "8px 10px", borderBottom: "1px solid #e5e8eb", fontSize: "13px", verticalAlign: "top" };
    const head: React.CSSProperties = { ...cell, fontWeight: 600, color: "#6B7684", background: "#F5F6F8", whiteSpace: "nowrap" };

    return (
        <Modal open={!!props.open} onClose={props.onClose}>
            <ModalDialog sx={{ width: "640px", maxWidth: "96vw", maxHeight: "90vh", overflow: "auto" }}>
                <div style={{ fontSize: "18px", fontWeight: 600, marginBottom: "4px" }}>
                    결제링크 발송 이력
                </div>
                <div style={{ fontSize: "13px", color: "#6B7684", marginBottom: "16px" }}>
                    {props.target ? `${props.target.name} · ${props.target.phoneNumber || ""}` : ""} · 성공 {successRows.length}회
                    {rows.length > successRows.length ? ` (실패·대기 ${rows.length - successRows.length}건은 횟수에 포함되지 않음)` : ""}
                </div>

                {loading ? (
                    <div style={{ display: "flex", justifyContent: "center", padding: "30px 0" }}><CircularProgress size="sm" /></div>
                ) : rows.length === 0 ? (
                    <div style={{ padding: "24px 0", textAlign: "center", color: "#6B7684", fontSize: "13px" }}>발송 이력이 없습니다</div>
                ) : (
                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        <thead>
                            <tr>
                                <th style={head}>#</th>
                                <th style={head}>발송 시각</th>
                                <th style={head}>결과</th>
                                <th style={head}>발송자</th>
                                <th style={head}>지점</th>
                                <th style={head}>링크</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((r, index) => {
                                const ok = r.status === "success";
                                const pending = r.status === "pending";
                                // 번호는 성공 건만 센다(최신이 위라 역순)
                                const no = ok ? successRows.length - successRows.findIndex((s) => s.id === r.id) : "";
                                return (
                                    <tr key={r.id} style={{ color: ok ? "#191f28" : "#8B95A1" }}>
                                        <td style={cell}>{no}</td>
                                        <td style={{ ...cell, whiteSpace: "nowrap" }}>{formatDateTime(ok ? r.sentAt : r.createdAt)}</td>
                                        <td style={cell}>
                                            {ok ? <span style={{ color: "#1B64DA", fontWeight: 600 }}>성공{r.deliveryStatusCode === "unknown" ? " (수신 확인 안 됨)" : r.deliveryStatusCode ? " · 수신 완료" : " · 확인 중"}</span>
                                                : pending ? <span>발송 중</span>
                                                : <span style={{ color: "#E8505B", fontWeight: 600 }}>실패{r.errorMessage ? ` · ${r.errorMessage}` : ""}</span>}
                                        </td>
                                        <td style={{ ...cell, whiteSpace: "nowrap" }}>{r.sentByName || "-"}</td>
                                        <td style={{ ...cell, whiteSpace: "nowrap" }}>{r.location || r.dueLabel || "-"}</td>
                                        <td style={cell}>
                                            {r.url ? <a href={r.url} target="_blank" rel="noreferrer" style={{ color: "#1B64DA", wordBreak: "break-all" }}>{r.url.replace("https://", "")}</a> : "-"}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}

                <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                    <Button variant="outlined" color="neutral" onClick={props.onClose}>닫기</Button>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default WinterSendHistoryModal;
